import React, { useEffect, useRef, useState } from 'react';
import { setPageTitle } from '@/utils/pageTitle';
import './cohort-view-user.styles.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { ModalAlert } from '../modal/modal.component';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import StatusBarWithIcons from '@/components/HOME/my-microcredentials/status-bar-with-icons.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';
import ThreeDotsLoaderSmall from '../loader/three-dots-loader-small.component';

const CohortViewUser = ({
    cohort,
    userList,
    mcList,
    progressNumbers
}) => {

    const { cstKey } = useParams();
    const [ user, setUser ] = useState(null);
    const [ userMcs, setUserMcs ] = useState(null);
    const [ nfeRegs, setNfeRegs ] = useState({});
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ loading, setLoading ] = useState(true);
    const approveRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        if (!cohort?.name) return;
        setPageTitle(`${cohort.name} Participant`);
    }, [cohort?.name])

    useEffect(() => {
        if (!cstKey || !userList) return;
        getUserNfeRegs();
        let u = userList[cstKey];
        if (!u) {
            setAlertMessage('Sorry there has been an issue. No user was found.');
            approveRef.current = () => {
                navigate(-1);
                return;
            }
            return;
        }
        setUser({...u});
    }, [cstKey, userList])

    useEffect(() => {
        if (!user) return;

    }, [user])

    async function getUserNfeRegs() {
        const res = await UseCloudFunction(
            'getUserMcListFromNfe',
            {
                'profile': {
                    'cst_key': cstKey
                }
            }
        )
        console.log(res);
        let regs = {}
        for (let reg of res) {
            regs[reg.evt_key] = new Date(reg.add_date).getTime();
        }
        setNfeRegs(regs);
        setLoading(false);
    }

    return (
        <div className='cohort-view-user'>
            {
                (user && cohort) &&
                <div className='cohort-view-user-content'>
                    <div className='user-title'>
                        <div>
                            <UserIcon profile={user} large={true} />
                        </div>
                        <div className='user-name'>
                            <div className='name'>{user.fName} {user.lName}</div>
                            <div className='email meta'>
                                <a href={`mailto:${user.email}`} target="_blank">
                                    <button className='g-button text-only'>{user.email}</button>
                                </a>
                            </div>
                            <div className='meta'>{user.cst_key}</div>
                        </div>
                        <div className='cohort-info'>
                            {cohort.name}
                            <img src={cohort.icon} className='cohort-icon' />
                        </div>
                    </div>
                    <hr />

                    <section className='user-mc-list'>
                    {
                        (mcList) &&
                        Object.values(mcList)
                        .sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                        .map(mc => (
                            <div key={mc.mc_key} className='g-list-item' >
                                <div className=' progress-bar'>
                                    <div className='title-box'>
                                        <img src={mc.imageUrl} />
                                        <div>
                                            {mc.name}
                                            {/* <div className='meta'>{mc.mc_key}</div> */}
                                            {
                                                (loading)
                                                ?
                                                <div className='meta'><ThreeDotsLoaderSmall /></div>
                                                :
                                                (nfeRegs[mc.mc_key]) 
                                                ?
                                                <div className='meta'>Purchased {format(new Date(nfeRegs[mc.mc_key]), "P")}</div>
                                                :
                                                <div className='meta'>Not yet purchased</div>
                                            }
                                        </div>
                                    </div>
                                    <div className='icon-box'>
                                        {
                                            (nfeRegs[mc.mc_key]) &&
                                            <>
                                            <StatusBarWithIcons 
                                                progressNumber={
                                                    progressNumbers[mc.mc_key] 
                                                    ? progressNumbers[mc.mc_key][user.cst_key] 
                                                    : 0
                                                } 
                                                mcData={mc} />
                                            {
                                                (progressNumbers[mc.mc_key] && progressNumbers[mc.mc_key][user.cst_key]?.legacy) 
                                                ?
                                                <button 
                                                    className='g-button small-btn'
                                                    onClick={() => setAlertMessage('This Micro-Credential was completed in a legacy version of this platform. There is no data in this version.')}>
                                                    <FontAwesomeIcon icon={faEyeSlash} />
                                                </button>
                                                :
                                                <button 
                                                    className='g-button small-btn'
                                                    onClick={() => navigate(`../progress/${mc.mc_key}_${user.cst_key}`)}>
                                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                </button>
                                            }
                                            </>
                                        }
                                    </div>
                                    
                                </div>
                            </div>
                        ))
                    }
                    </section>
                </div>
            }
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
                onApprove={approveRef.current} />
        </div>
    )
}

export default CohortViewUser